/**
 * Extracts the YouTube Video ID from a standard URL or Shorts URL.
 */
export const getYoutubeVideoId = (url) => {
  if (!url) return null;
  const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
};

/**
 * Guesses if the video is vertical (9:16) based on the presence of '/shorts/'.
 */
export const isYoutubeShort = (url) => {
  if (!url) return false;
  return url.includes('/shorts/');
};